/*
 * Copyright (c) 2021 by Leyton Group - All Rights Reserved.
 *  This source code, and resulting software, is the confidential and proprietary information
 *  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
 *  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
 *  and shall use it only in accordance with the terms and conditions of any and all license
 *  agreements you have entered into with The Company.
 */

import moment from "moment";
import { simulationService } from "./simulation.service";
import { precarityService } from "./precarity.service";

import store from "@/store";
import Vue from "vue";

const checkConditions = function(tabFiche) {
  const res = tabFiche.fiche.$model.calculs.filter(calcul => {
    let satisfiedConditions = 0;
    tabFiche.conditions.$model.forEach(ficheCondition => {
      if (
        calcul.conditions.filter(
          calculCondition =>
            calculCondition.emmy.id === ficheCondition.emmy.id &&
            calculCondition.condition.value === ficheCondition.emmy.value
        ).length > 0
      ) {
        satisfiedConditions++;
      }
    });
    return satisfiedConditions === tabFiche.conditions.$model.length;
  });
  if (res.length > 0) {
    tabFiche.calculFormula.$model = res[0];
  } else {
    tabFiche.calculFormula.$model = {
      items: []
    };
    Vue.prototype.$notification.warning(
      "L’opération n’est pas éligible à une valorisation de CEE"
    );
    tabFiche.fiche.$model.calculs.forEach(() => {
      tabFiche.conditions.$model.forEach(
        ficheCondition => (ficheCondition.emmy.value = "")
      );
    });
  }
};

const getFormConditions = function(tabFiche) {
  tabFiche.conditions.$model = [];
  tabFiche.fiche.$model = {};
  tabFiche.calculFormula.$model = {};
  const ficheId = tabFiche.ficheNumber.$model;
  const zone = tabFiche.$model.climateZone;
  simulationService.fetchFicheById(ficheId, zone).then(res => {
    tabFiche.fiche.$model = res;
    const unFilteredConditions = tabFiche.fiche.$model.calculs.flatMap(
      calcul => calcul.conditions
    );
    unFilteredConditions.forEach(condition => {
      if (
        tabFiche.conditions.$model.filter(
          cnd => cnd.emmy.id === condition.emmy.id
        ).length === 0
      ) {
        tabFiche.conditions.$model.push(condition);
      }
    });
    if (tabFiche.conditions.$model.length === 0) {
      tabFiche.calculFormula.$model = tabFiche.fiche.$model.calculs[0];
    }
  });
};

const setPeriod = function(tabFiche, periods) {
  if (!tabFiche.provisionalBeginDate.$invalid) {
    tabFiche.period.$model = "";
    periods.forEach(prd => {
      const beginDate = moment(prd.beginDate, "DD-MM-YYYY hh:mm:ss");
      const endDate = moment(prd.endDate, "DD-MM-YYYY hh:mm:ss");
      if (
        moment(tabFiche.provisionalBeginDate.$model, "YYYY-MM-DD").isBetween(
          beginDate,
          endDate
        )
      ) {
        tabFiche.period.$model = prd;
      }
    });
  }
  if (!tabFiche.period.$model) {
    alert("période invalide");
  }
};

const fetchFiches = function(tabFiche) {
  if (
    !tabFiche.activityArea.$invalid &&
    !tabFiche.workType.$invalid &&
    !tabFiche.provisionalBeginDate.$invalid
  ) {
    tabFiche.ficheNumber.$model = "";
    const sector = tabFiche.activityArea.$model;
    const type = tabFiche.workType.$model;
    const beginDate = moment(tabFiche.provisionalBeginDate.$model).format("x");
    simulationService.fetchFiches(sector, type, beginDate).then(fiches => {
      tabFiche.fiches.$model = fiches;
    });
  }
};

const updatePrecarities = function(tabsFiche, address) {
  const departmentCode = address.departmentCode.$model;
  tabsFiche
    .filter(fiche => fiche.addressIndex === address.$model.tabAddressIndex)
    .forEach(tabFiche => {
      const periodId = tabFiche.period.id;
      precarityService.fetchPrecarity(periodId, departmentCode).then(res => {
        tabFiche.precarityControl.id = res.id;
        tabFiche.precarityControl.periodId = tabFiche.period.id;
        tabFiche.precarityControl.department = res.departementCode;
        tabFiche.precarityControl.couplePercentagePrecarityByDepartment =
          res.percentHigh;
        tabFiche.precarityControl.couplePercentageBigPrecarityByDepartment =
          res.percentLow;
      });
    });
};

const fetchCityByZipCode = function(tabsFiche, departments, address) {
  address.city.$model = "";
  address.climateZone.$model = "";
  address.cities.$model = [];
  simulationService.fetchCityByZipCode(address.zipCode.$model).then(addr => {
    address.cities.$model = addr;
    const _departementLength = 2;
    address.departmentCode.$model = address.zipCode.$model.substring(
      0,
      _departementLength
    );
    address.climateZone.$model = departments.find(
      value => value.code === address.departmentCode.$model
    ).zone;
    tabsFiche
      .filter(fiche => fiche.addressIndex === address.$model.tabAddressIndex)
      .forEach(tabFiche => {
        tabFiche.climateZone = address.climateZone.$model;
        tabFiche.departmentCode = address.departmentCode.$model;
      });
  });
};

const newTabFiche = function(
  tabsAddress,
  tabsFiche,
  $v,
  selectedAddress,
  tabFicheIndex
) {
  if (
    tabsAddress.length &&
    !$v.tabsAddress.$invalid &&
    !$v.tabsFiche.$invalid
  ) {
    tabsFiche.push({
      addressIndex: tabsAddress[selectedAddress].tabAddressIndex,
      tabFicheIndex: tabFicheIndex,
      id: "",
      provisionalBeginDate: "",
      provisionalCompletionDate: "",
      workType: "",
      activityArea: "",
      ficheNumber: "",
      departmentCode: tabsAddress[selectedAddress].departmentCode,
      climateZone: tabsAddress[selectedAddress].climateZone,
      precarityControl: {
        bigPrecarity: false,
        precarity: "NO",
        coupleNumber: "",
        coupleNumberInSocialHousing: "",
        couplePercentagePrecarity: "",
        couplePercentageBigPrecarity: "",
        coupleNumberPrecarity: "",
        coupleNumberBigPrecarity: "",
        periodId: "",
        department: "",
        couplePercentagePrecarityByDepartment: "",
        couplePercentageBigPrecarityByDepartment: ""
      },
      workTypes: [],
      fiches: [],
      fiche: {},
      conditions: [],
      calculFormula: {
        items: []
      }
    });
  } else {
    $v.tabsAddress.$touch();
    $v.tabsFiche.$touch();
  }
};

const newTabAdresse = function(tabsAddress, $v, tabAddressIndex) {
  if (!$v.tabsAddress.$invalid && !$v.tabsFiche.$invalid) {
    tabsAddress.push({
      tabAddressIndex: tabAddressIndex,
      id: "",
      workAddress: "",
      way: "",
      additionalInfo: "",
      zipCode: "",
      departmentCode: "",
      city: "",
      climateZone: "",
      cities: []
    });
  } else {
    $v.tabsAddress.$touch();
    $v.tabsFiche.$touch();
  }
};

const prepareConditions = function(calcul) {
  const conditions = [];
  calcul.conditions.forEach(ficheCondition => {
    conditions.push({
      condition: {
        id: ficheCondition.condition.id,
        value: ficheCondition.condition.value
      }
    });
  });
  return conditions;
};

const prepareCalculation = function(items) {
  const calculationItems = [];
  items.forEach(item => {
    const calculationItem = {};
    calculationItem.id = item.id;
    calculationItem.index = item.index;
    calculationItem.name = item.name;
    calculationItem.ficheCalculItemFicheEmmies = [];
    calculationItem.calculationItems = [];
    calculationItem.fichePonderations = item.fichePonderations;
    item.ficheCalculItemFicheEmmies.forEach(ficheCalculItemFicheEmmie => {
      const ficheCalculItemFicheEmmy = {};
      ficheCalculItemFicheEmmy.id = ficheCalculItemFicheEmmie.id;
      ficheCalculItemFicheEmmy.index = ficheCalculItemFicheEmmie.index;
      ficheCalculItemFicheEmmy.ficheEmmy = ficheCalculItemFicheEmmie.ficheEmmy;
      calculationItem.ficheCalculItemFicheEmmies.push(
        JSON.parse(JSON.stringify(ficheCalculItemFicheEmmy))
      );
      const variable = ficheCalculItemFicheEmmie.ficheEmmy;
      if (
        (variable.emmy.type === "LIST" && !variable.enterable) ||
        variable.emmy.type === "CLIMATIC_ZONE"
      ) {
        ficheCalculItemFicheEmmy.selectedValue = variable.emmy.listConditions.filter(
          elm => elm.value === variable.emmy.value
        )[0];
      } else {
        ficheCalculItemFicheEmmy.value = variable.emmy.value;
      }
      delete ficheCalculItemFicheEmmy.id;
      delete ficheCalculItemFicheEmmy.index;
      calculationItem.calculationItems.push(ficheCalculItemFicheEmmy);
    });
    calculationItems.push(calculationItem);
  });
  return calculationItems;
};

const persistEstimations = function(
  tabsAddress,
  tabsFiche,
  beneficiary,
  simulationId,
  isImportInMass = false
) {
  const ficheAddress = [];
  tabsAddress.forEach(tabAddr => {
    ficheAddress.push({
      address: {
        tabAddressIndex: tabAddr.tabAddressIndex,
        id: tabAddr.id,
        addressNumber: tabAddr.workAddress,
        addressRoad: tabAddr.way,
        additionalAddress: tabAddr.additionalInfo,
        postalCode: tabAddr.zipCode,
        city: tabAddr.city,
        country: null
      },
      beneficiary: beneficiary,
      operations: []
    });
  });
  const fiches = [];
  tabsFiche.forEach(tabFiche => {
    fiches.push({
      addressIndex: tabFiche.addressIndex,
      id: tabFiche.id,
      beginDate: moment(tabFiche.provisionalBeginDate).format("x"),
      endDate: tabFiche.provisionalCompletionDate
        ? moment(tabFiche.provisionalCompletionDate).format("x")
        : null,
      fiche: {
        id: tabFiche.fiche.id
      },
      ficheEmmiesRemaining: tabFiche.calculFormula.ficheEmmies.map(fe => ({
        ficheEmmy: fe,
        text: fe.emmy.value,
        selectedValue: fe.emmy.selectedValue
      })),
      ficheCalcul: {
        id: tabFiche.calculFormula.id,
        calcul: tabFiche.calculFormula.calcul,
        conditions: prepareConditions(tabFiche.calculFormula),
        precarity: {
          precarityCase: tabFiche.precarityControl.precarity,
          bigPrecarity: tabFiche.precarityControl.bigPrecarity,
          coupleNumber: tabFiche.precarityControl.coupleNumber,
          coupleNumberBigPrecarity:
            tabFiche.precarityControl.coupleNumberBigPrecarity,
          coupleNumberInSocialHousing:
            tabFiche.precarityControl.coupleNumberInSocialHousing,
          coupleNumberPrecarity:
            tabFiche.precarityControl.coupleNumberPrecarity,
          precarite: {
            id: tabFiche.precarityControl.id,
            departementCode: tabFiche.precarityControl.department,
            percentHigh:
              tabFiche.precarityControl.couplePercentagePrecarityByDepartment,
            percentLow:
              tabFiche.precarityControl
                .couplePercentageBigPrecarityByDepartment,
            periodID: tabFiche.precarityControl.periodId
          }
        },
        items: prepareCalculation(tabFiche.calculFormula.items),
        ficheEmmies: tabFiche.calculFormula.ficheEmmies
      }
    });
  });
  ficheAddress.forEach(ficheAddr => {
    fiches.forEach(fiche => {
      if (ficheAddr.address.tabAddressIndex === fiche.addressIndex) {
        delete fiche.addressIndex;
        ficheAddr.operations.push(fiche);
      }
    });
    delete ficheAddr.address.tabAddressIndex;
  });

  const data = {
    simulationId: simulationId,
    ficheAddress: ficheAddress,
    isImportInMass: isImportInMass
  };
  return store.dispatch("simulation/persistEstimationsAction", { data: data });
};

export const estimationService = {
  checkConditions,
  getFormConditions,
  setPeriod,
  fetchFiches,
  updatePrecarities,
  fetchCityByZipCode,
  newTabFiche,
  newTabAdresse,
  persistEstimations
};
